var EregAuthErrorView = require('./EregAuthErrorView');

/**
 * Error View when the Barcode Data is Invalid
 *
 * @class NoBarcodeDataErrorView
 * @constructor
 */
module.exports = EregAuthErrorView.extend({
  errorMessageKey: 'eregAuth.error.BarcodeDataInvalid.message.final',
  buttonOneMessageKey: 'eregAuth.error.button.ok'
});
